/**
* Displays an authentication modal to users who are not authenticated, with configurable display time and timeout.
* The modal is shown after a specified delay unless a cookie indicates it was recently closed. When the modal is closed,
* a cookie is set to prevent it from reappearing for a defined timeout period.
*
* @function
* @returns {void}
*
* @description
* - Reads display time (in seconds) and timeout (in minutes) from data attributes on the authentication wrapper element, if present.
* - Checks for a cookie ('authModalClosed') to determine if the modal should be shown.
* - Shows the modal after the configured delay if the cookie is not set to 'true'.
* - Sets a cookie when the modal is closed to prevent it from being shown again within the timeout period.
*/
function isNotAuthenticatedModal() {
    const $authenticatedModal = $("#authenticatedModal");
    const $authenticateWrapper = $("#js-authenticate");
    let modalDisplayTime = 3; // in seconds
    let modalTimeOut = 30; // in minutes

    // overwrite the default values if data attributes exist
    if ($authenticateWrapper.length) {
        if ($authenticateWrapper.data("display-time")) {
            modalDisplayTime = Number($authenticateWrapper.data("display-time"));
        }

        if ($authenticateWrapper.data("time-out")) {
            modalTimeOut = Number($authenticateWrapper.data("time-out"));
        }
    }

    // Check if cookie exists
    const isModalClosed = document.cookie
        .split("; ")
        .find(row => row.startsWith("authModalClosed="))
        ?.split("=")[1];

    if ($authenticatedModal.length && isModalClosed !== "true") {
        setTimeout(() => {
            $authenticatedModal.modal("show");
        }, modalDisplayTime * 1000);

        // Set cookie only once when modal is closed
        $authenticatedModal.one("hidden.bs.modal", function () {
            const expiryDate = new Date();
            expiryDate.setTime(
                expiryDate.getTime() + (modalTimeOut * 60 * 1000)
            );

            document.cookie =
                "authModalClosed=true; expires=" +
                expiryDate.toUTCString() +
                "; path=/";
        });
    }
}

/**
* This allows other modules to import and use the isNotAuthenticatedModal functionality.
* @module client/default/js/components/notAuthenticatedModal
*/
module.exports = {
    isNotAuthenticatedModal
};
